

export const index = 3;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/kontakt/_page.svelte.js')).default;
export const imports = ["_app/immutable/nodes/3.DV50IxSu.js","_app/immutable/chunks/DowcGjab.js","_app/immutable/chunks/BzCi4Of2.js","_app/immutable/chunks/DuUomSZU.js"];
export const stylesheets = ["_app/immutable/assets/3.DYIOIu42.css"];
export const fonts = [];
